/* eslint-disable @typescript-eslint/no-explicit-any */
export type FieldType = "boolean" | "select" | "number" | "text" | "date";

export type NumberFormat =
  | "number" // Default: plain number
  | "currency" // Price with currency symbol
  | "area_m2" // Square meters (m²)
  | "volume_m3" // Cubic meters (m³)
  | "percentage" // Percentage (%)
  | "decimal"; // Number with decimal places

export interface BaseField {
  id: string;
  label: string;
  type: FieldType;
  description?: string;
  required: boolean;
  options?: string[];
  min?: number;
  max?: number;
  default?: any;
  numberFormat?: NumberFormat; // Format for number fields
}

/** Shared by the field editor and the qualification form's question cards. */
export const TYPE_COLORS: Record<FieldType, string> = {
  boolean: "bg-info-soft text-info-foreground",
  select: "bg-purple/12 text-purple",
  number: "bg-success-soft text-success-foreground",
  text: "bg-warning-soft text-warning-foreground",
  date: "bg-pink/12 text-pink",
};

/** In menu order; each is labelled by `fieldEditor.types.<type>`. */
export const FIELD_TYPES: FieldType[] = [
  "boolean",
  "select",
  "number",
  "text",
  "date",
];

/** In menu order; each is labelled by `fieldEditor.numberFormats.<format>`. */
export const NUMBER_FORMATS: NumberFormat[] = [
  "number",
  "currency",
  "area_m2",
  "volume_m3",
  "percentage",
  "decimal",
];
